define('app/views/home',['require','./page'],function(require){

  var Page = require('./page');

  return Page.extend({

    view: 'home',

    beforeRender: function(){
      this.model.set('SLIDES', _.shuffle(this.model.get('SLIDES')));
    }

  });

});
